import React from "react"
import { getAssetPath } from "@commonUtils"
import OrderPlaced from "@widgets/OrderPlaced/OrderPlaced"

const successTick = getAssetPath("svgs/icons/tickStar.svg")

function BosSuccessPage() {
    return (
        <OrderPlaced
            col={24}
            header="BOS plan purchased"
            internalData={{ internalSubHeader: "Your payment has been successfully completed." }}
            image={{
                url: successTick,
                height: "48",
                width: "48",
            }}
        />
    )
}

export default BosSuccessPage
